import { VendorDocumentsListVendor } from '../../components/Vendor';
import { usePageTitle } from '../../hooks';

export function Documents() {
  usePageTitle('vendor:document.title');
  return <VendorDocumentsListVendor />;
}
